import { Route, RouteObject } from 'react-router-dom';
import IntegrationDashboard from './components/landing/IntegrationDashboard';
import { PaymentGatewayConfig } from './components/landing/PaymentGatewayConfig';

export interface ixIntegrationRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: ixIntegrationRoute[];
}

export const ixIntegrationRoutes: ixIntegrationRoute[] = [
   {
      path: 'integration-hub/integration',
      element: <IntegrationDashboard />,
    },
    {
      path: 'integration-hub/integration/payments',
      element: <PaymentGatewayConfig />,
    },
    
]